import React from "react";
import { GridItem } from "@sainsburys-tech/fable";
import StoreZoneReviewItem from "./StoreZoneReviewItem";
import PropTypes from "prop-types";

const StoreZoneReviewList = props => {
  return (
    <React.Fragment>
      {props.zones.map((zone, index) => {
        return (
          <GridItem
            colSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
            key={index}
          >
            <StoreZoneReviewItem
              {...zone}
              setConfirmationDialog={props.setConfirmationDialog}
            />
          </GridItem>
        );
      })}
    </React.Fragment>
  );
};

StoreZoneReviewList.propTypes = {
  zones: PropTypes.arrayOf(
    PropTypes.shape({
      storeId: PropTypes.string,
      scenes: PropTypes.arrayOf(
        PropTypes.shape({
          levelPercentage: PropTypes.shape({
            isOn: PropTypes.bool,
            levelPercentage: PropTypes.number,
            rampTimeSeconds: PropTypes.number
          }),
          name: PropTypes.string
        })
      ),
      zoneId: PropTypes.string,
      zoneName: PropTypes.string,
      luxMeterCbusGroupId: PropTypes.number,
      lightsCbusGroupId: PropTypes.number,
      hasLuxMeter: PropTypes.bool,
      pirSensorIds: PropTypes.arrayOf(PropTypes.number)
    })
  ),
  setConfirmationDialog: PropTypes.func,
  featureLightingGroupId: PropTypes.number,
  counterLightingGroupId: PropTypes.number
};

export default StoreZoneReviewList;
